import type { EditorState } from '../store/editorState';

const selectNotifications = (state: EditorState) => state.notifications;

export { selectNotifications };
